import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ButtonMob, instanceMob, Loadingspinner } from "../../../utils/utils";
import { ReactComponent as DeleteTag } from "../../../assets/elevva-pro-icons/delete-tag.svg";
import { ReactComponent as ArrowDown } from "../../../assets/elevva-pro-icons/arrowWhite-down.svg";
import { ReactComponent as ArrowUp } from "../../../assets/elevva-pro-icons/arrowWhite-up.svg";
import ConfirmDeletionModal from "./modal-delete";

const ModalBookingWaitList = ({
  onCancel,
  id,
  startTime,
  name,
  upDateBooking,
  slots,
  wait_total,
}) => {
  const styleModal = {
    display: "flex",
    position: "fixed",
    zIndex: 999,
    whiteSpace: "pre-line",
  };

  const [availability, setAvailability] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalDelete, setModalDelete] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [arrowAteendes, setArrowAteendes] = useState(false);
  const [arrowWait, setArrowWait] = useState(false);
  const [totalAttendes, setTotalAtteendes] = useState(0);
  const [totalWait, setTotalWait] = useState(0);

  function findFirstWithBookingsAttendes(data) {
    // Buscar en bookings
    for (const [key, value] of Object.entries(data.bookings)) {
      if (value.length > 0) {
        return { type: "bookings", time: key, data: value[0] };
      }
    }

    // Buscar en wait_bookings

    // Si ninguno tiene datos
    return null;
  }
  function findFirstWithBookingsWaitList(data) {
    // Buscar en wait_bookings

    for (const [key, value] of Object.entries(data.wait_bookings)) {
      if (value.length > 0) {
        return { type: "wait_bookings", time: key, data: value[0] };
      }
    }

    // Si ninguno tiene datos
    return null;
  }

  function getAvailability() {
    setLoading(true);
    instanceMob
      .get(
        `admin/availability/bookings?start_time=${startTime}&availability_id=${id}`
      )
      .then((res) => res.data)
      .then((data) => {
        let attende = findFirstWithBookingsAttendes(data);
        setTotalAtteendes(attende?.data?.total_bookings || 0);
        let waitList = findFirstWithBookingsWaitList(data);
        setTotalWait(waitList?.data?.total_bookings || 0);
        setAvailability(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }
  function cancelBookingId(id) {
    const handleDelete = () => {
      let formData = new FormData();
      formData.append("pk", id);
      instanceMob
        .post(`admin/booking/cancel`, formData)
        .then((res) => {
          if (res.status == "204" || res.status == "200") {
            setModalDelete(null);
            getAvailability();
            upDateBooking();
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error) {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                <PerfectScrollbar style={{ maxHeight: "10rem" }}>
                  {msg_error}
                </PerfectScrollbar>
              </ConfirmDeletionModal>
            );
          }
        });
    };

    setModalDelete(
      id && (
        <ConfirmDeletionModal
          onCancel={() => setModalDelete(null)}
          onConfirm={handleDelete}
          loader={false}
        >
          ¿Estás seguro de <br></br>
          <strong>eliminar este asistente? </strong>
        </ConfirmDeletionModal>
      )
    );
  }
  useEffect(() => {
    getAvailability();
  }, [id, startTime]);

  return (
    <div
      className="popUpServices justify-content-center align-items-center"
      style={styleModal}
    >
      {modalError}
      {modalDelete}
      <div
        className="modalInfoContenido"
        style={{
          background: "white",
          borderRadius: "20px",
          boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
          padding: "6% 10%",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "6%",
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: " #9DACBD",
            cursor: "pointer",
          }}
          onClick={onCancel}
        >
          <i className="bi bi-x-circle"></i>
        </div>

        <div
          className="pt-3 my-4 mx-auto"
          style={{
            lineHeight: "100%",
            textAlign: "center",

            color: "var(--elevvabutonLogin_User)",
          }}
        >
          <div className="mb-2">
            <strong>Resumen de asistentes</strong>
          </div>
          <div className="my-1">{name}</div>
          <div>{startTime}</div>
          <hr></hr>
          <div className="d-flex justify-content-center align-items-center gap-5 my-2">
            <div className="d-flex flex-column">
              <span style={{ fontSize: "calc(.5rem + .4vw)" }}>Cupos</span>
              <span>
                {totalAttendes}/{slots}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span style={{ fontSize: "calc(.5rem + .4vw)" }}>
                Lista de espera
              </span>
              <span>
                {totalWait}/{wait_total}
              </span>
            </div>
          </div>
          <hr></hr>
          {loading ? (
            <>
              <div className="my-2" style={{ minWidth: "20rem" }}>
                <Loadingspinner customStyle="grow" size="2.5rem" />
              </div>
            </>
          ) : (
            <>
              {" "}
              <div
                className="d-flex flex-col m-auto justify-content-center align-items-center gap-4"
                style={{ minWidth: "25rem" }}
              >
                {" "}
                {/* booking */}
                <div className="w-100">
                  <div className="w-100">
                    <button
                      onClick={() => setArrowAteendes(!arrowAteendes)}
                      style={{
                        background: "#3177BE",
                        color: "white",
                        border: "none",
                        borderRadius: "20px",
                        padding: "0.5rem 1rem",
                      }}
                      className="d-flex w-100 justify-content-between align-items-center gap-3 my-2"
                    >
                      Asistentes {arrowAteendes ? <ArrowDown /> : <ArrowUp />}
                    </button>
                  </div>

                  {arrowAteendes && (
                    <>
                      {" "}
                      {availability?.bookings &&
                      Object.keys(availability.bookings).length > 0 ? (
                        <div className="w-100">
                          <PerfectScrollbar
                            style={{ maxHeight: "10rem" }}
                            className="d-flex my-3 flex-column w-100"
                          >
                            {Object.values(availability.bookings).map(
                              (e) =>
                                e[0]?.users &&
                                e[0].users.map((e, index) => {
                                  return (
                                    <div
                                      key={index + "user-in-booking"}
                                      className="d-flex w-100 justify-content-between align-items-center gap-3 px-2 pb-2"
                                      style={{
                                        borderBottom: "1px solid #A8C2D7",
                                      }}
                                    >
                                      <div>{e.customer_name}</div>
                                      <div
                                        className="cursor-pointer"
                                        onClick={() =>
                                          cancelBookingId(e.booking_id)
                                        }
                                      >
                                        <DeleteTag width={"100%"} />
                                      </div>
                                    </div>
                                  );
                                })
                            )}
                          </PerfectScrollbar>
                        </div>
                      ) : (
                        <div>No hay asistentes</div>
                      )}
                    </>
                  )}
                </div>
              </div>
              {/* wait_bookings */}
              <div
                className="d-flex flex-col m-auto justify-content-center align-items-center gap-4"
                style={{ minWidth: "20rem" }}
              >
                <div className="w-100">
                  <div className="w-100">
                    <button
                      onClick={() => setArrowWait(!arrowWait)}
                      style={{
                        background: "#3177BE",
                        color: "white",
                        border: "none",
                        borderRadius: "20px",
                        padding: "0.5rem 1rem",
                      }}
                      className="d-flex w-100 justify-content-between align-items-center gap-3 my-2"
                    >
                      Lista de espera {arrowWait ? <ArrowDown /> : <ArrowUp />}
                    </button>
                  </div>
                  {arrowWait && (
                    <>
                      {" "}
                      {availability?.wait_bookings &&
                      Object.keys(availability.wait_bookings).length > 0 ? (
                        <div className="w-100">
                          <PerfectScrollbar
                            style={{ maxHeight: "10rem" }}
                            className="d-flex my-3 w-70 flex-column"
                          >
                            {Object.values(availability.wait_bookings).map(
                              (e) =>
                                e[0]?.users &&
                                e[0].users.map((e, index) => {
                                  return (
                                    <div
                                      key={index + "user-in-booking"}
                                      className="d-flex w-100 justify-content-between align-items-center gap-3 px-2 py-2"
                                      style={{
                                        borderBottom: "1px solid #A8C2D7",
                                      }}
                                    >
                                      <div>{e.customer_name}</div>
                                      <div
                                        className="cursor-pointer"
                                        onClick={() =>
                                          cancelBookingId(e.booking_id)
                                        }
                                      >
                                        <DeleteTag width={"100%"} />
                                      </div>
                                    </div>
                                  );
                                })
                            )}
                          </PerfectScrollbar>
                        </div>
                      ) : (
                        <div>No hay asistentes</div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalBookingWaitList;
